import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetJobs = async (v) => {
    // Retrieve and decrypt the bearer token safely
    const encryptedToken = sessionStorage.getItem('token');
    const token = encryptedToken ? Decrypt(encryptedToken) : '';

    var config = {
        method: 'post',
        url: `${configData.API_ENDPOINT}jobs/get`,
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.error("API error inside GetJobs service:", error.response?.data || error.message);
            return error;
        });
}

export const GetJobById = async (id) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `jobs/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const CreateJob = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `jobs`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const UpdateJob = async (id, v) => {
    var config = {
        method: 'put',
        url: configData.API_ENDPOINT + `jobs/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const DeleteJob = async (id, v) => {
    var config = {
        method: 'delete',
        url: configData.API_ENDPOINT + `jobs/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetUploadUrl = async (id, filename) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `jobs/upload/${id}/${filename}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}